/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Ocr_FailedInputs */

const en_ocr_failed = /** @type {(inputs: Ocr_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`OCR processing failed: ${i?.error}`)
};

const fr_ocr_failed = /** @type {(inputs: Ocr_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec du traitement OCR : ${i?.error}`)
};

const de_ocr_failed = /** @type {(inputs: Ocr_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`OCR-Verarbeitung fehlgeschlagen: ${i?.error}`)
};

const it_ocr_failed = /** @type {(inputs: Ocr_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Elaborazione OCR non riuscita: ${i?.error}`)
};

const ru_ocr_failed = /** @type {(inputs: Ocr_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сбой обработки OCR: ${i?.error}`)
};

const es_ocr_failed = /** @type {(inputs: Ocr_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El procesamiento OCR falló: ${i?.error}`)
};

const zh_cn2_ocr_failed = /** @type {(inputs: Ocr_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`OCR 处理失败：${i?.error}`)
};

const ja_ocr_failed = /** @type {(inputs: Ocr_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`OCR処理に失敗しました: ${i?.error}`)
};

const hi_ocr_failed = /** @type {(inputs: Ocr_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`OCR प्रोसेसिंग विफल: ${i?.error}`)
};

const pt_pt2_ocr_failed = /** @type {(inputs: Ocr_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha no processamento OCR: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "OCR processing failed: {error}" |
*
* @param {Ocr_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_failed = /** @type {((inputs: Ocr_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_failed(inputs)
	if (locale === "de") return de_ocr_failed(inputs)
	if (locale === "it") return it_ocr_failed(inputs)
	if (locale === "ru") return ru_ocr_failed(inputs)
	if (locale === "es") return es_ocr_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_failed(inputs)
	if (locale === "ja") return ja_ocr_failed(inputs)
	if (locale === "hi") return hi_ocr_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_failed(inputs)
	return en_ocr_failed(inputs)
});